import type { ZodObject, ZodRawShape } from 'zod';

export const getZodSchemaErrorMessages = <T extends ZodRawShape>({
  schema,
  fields,
  getAllFieldErrors = false,
}: {
  schema: ZodObject<T>;
  fields: unknown;
  getAllFieldErrors?: boolean;
}): Record<string, string> | null => {
  const parsedSchema = schema.safeParse(fields);

  if (parsedSchema.success) {
    return null;
  }

  const errors = parsedSchema.error.issues.reduce<Record<string, string[]>>(
    (accumulator, issue) => {
      const field = issue.path.join('.');

      if (!field) {
        return accumulator;
      }

      return {
        ...accumulator,
        [field]: [...(accumulator[field] || []), issue.message],
      };
    },
    {},
  );

  return Object.entries(errors).reduce<Record<string, string>>(
    (accumulator, [field, fieldErrors]) => ({
      ...accumulator,
      [field]: getAllFieldErrors ? fieldErrors.join(', ') : fieldErrors[0],
    }),
    {},
  );
};
